module.exports = __webpack_public_path__ + "img/6d7d4fb.png";